const ALLOWED_ENVS = ['tst', 'acc', 'prd'] as const
type AllowedEnv = (typeof ALLOWED_ENVS)[number]

export const resolveEnv = (): AllowedEnv => {
  const raw = import.meta.env.VITE_ENV as string | undefined
  if (raw && (ALLOWED_ENVS as readonly string[]).includes(raw)) {
    return raw as AllowedEnv
  }
  return 'tst'
}
